export enum Traits {
    SendPrescriptionsToRX = 1,
    BlockUsersFromManuallyAddingToVisit = 2,
    DisallowRemovalFromVisit = 3,
    HeartwormProtection = 4,
    FleaTickProtection = 5,
    AllowDecline = 6,
    MinimumWeight = 7,
    MaximumWeight = 8,
    IDEXXHeadlessOrder = 9,
    IDEXXOrder = 10,
    ReservationPreConfirmed = 11,
    ReservationOverbooked = 12,
    ReservationWalkIn = 13,
    SendLabResultstoPetParent = 14,
    IDEXXInHouseTest = 15,
    IsEuthanasia = 16,
    IsSpayNeuter = 17,
    IsControlled = 18,
    BarcodeNotRequired = 19,
    IsAnesthesiaMedication = 20,
    IncludeInWellnessSummary = 21,
    AllowedInPnpNewOrder = 22,
    AllowVisitSalesItemOptionUpdates = 23
}
